import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { ALL, ORDER_STATUS_SELECT_ITEMS, GET_ALL_CUSTOMER_URL, 
         PAGE_SIZE, ORDER_TYPE_SELECT_ITEMS, DAYS_YEAR} from '../../common/constants';
import { formatDate, isEmptyArray } from '../../common/util.services';
import './schedule-list.component.scss';
import { searchSchedule } from '../production.services';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import { Grid } from '@mui/material';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import dayjs from 'dayjs';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';

const ScheduleList = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const [scheduleData, setScheduleData] = useState(rows);
  const [searchData, setSearchData] = useState<any>({customer: ALL, 
                                                     status: ALL,
                                                     orderType: ALL,
                                                     orderPriority: ALL,
                                                     startDate: dayjs().subtract(DAYS_YEAR, 'day'), 
                                                     endDate: dayjs()});
  const columns: GridColDef[] = [
    { field: 'code', headerName: 'Code', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => { openEditPage(params.row) }}>{params.row.code}</div>}
    },
    { field: 'orderCode', headerName: 'Ord Code', filterable: false, sortable: false, editable: false, width: 100,
      renderCell: (params) => { return <div className="cell-link" 
      onClick={() => { openOrderPage(params.row) }}>{params.row.orderCode}</div>}
    },
    { field: 'enquiryCode', headerName: 'Enq Code', filterable: false, sortable: false, editable: false, width: 120,
      renderCell: (params) => { return <div className={'NA' !== params.row.enquiryCode ? "cell-link" : ""}
      onClick={() => { openEnquiryPage(params.row)}}>{params.row.enquiryCode}</div> }
    },
    { field: 'customer', headerName: 'Customer', filterable: false, sortable: false, editable: false, width: 170 },
    { field: 'orderType', headerName: 'Ord Type', filterable: false, sortable: false, editable: false, width: 100 },
    { field: 'orderPriority', headerName: 'Priority', filterable: false, sortable: false, editable: false, width: 80 },
    { field: 'status', headerName: 'Status', filterable: false, sortable: false, editable: false, width: 80 },
    { field: 'orderDate', headerName: 'Order Date', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (scheduleDate: any) => formatDate(scheduleDate)
    },
    { field: 'targetDate', headerName: 'Target Date', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (targetDate: any) => formatDate(targetDate)
    },
    { field: 'dispatchDate', headerName: 'LFH Target', filterable: false, sortable: false, editable: false, width: 100,
      valueFormatter: (dispatchDate: any) => formatDate(dispatchDate)
    },
    { field: 'daysLeft', headerName: 'Days Left', filterable: false, sortable: false, editable: false, width: 80 },
    { field: 'ageing', headerName: 'Ageing', filterable: false, sortable: false, editable: false, width: 65 },
    { field: 'remarks', headerName: 'Remarks', filterable: false, sortable: false, editable: false, width: 150 },
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      searchSchedule(searchData, page, pageSize, appContext,
        (response: any) => {
          setScheduleData(response.data.data);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [searchData, page, pageSize]);

  const search = (data: any) => {
    setSearchData(data);
  }

  const openEditPage = (row: any) => {
    navigate('/production/schedule/' + row.rowId, {state: {orderId: row.rowId, orderCode: row.code}});
  }

  const openOrderPage = (row: any) => {
    navigate('/enquiry/order/' + row.orderId, {state: {enquiryCode: "", customer: "", product: "", description: "", type: ""}})
  }

  const openEnquiryPage = (row: any) => {
    navigate('/enquiry/product/list/' + row.enquiryId)
  }

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1}>
        <Grid xs={2}>
          <ITextField name='searchText' label='Search Text' />
        </Grid>
        <Grid xs={2}>
          <IDropdown name='customer' label='Customer' url={GET_ALL_CUSTOMER_URL} allItemRequired={true}/>
        </Grid>
        <Grid xs={2}>
          <IDropdown name='status' label='Production Status' itemList={ORDER_STATUS_SELECT_ITEMS} allItemRequired={true} />
        </Grid>
        <Grid xs={1}>
          <IDropdown name='orderType' label='Order Type' itemList={ORDER_TYPE_SELECT_ITEMS} allItemRequired={true} />
        </Grid>
        <Grid xs={1}>
          <IDropdown name='orderPriority' label='Order Priority' itemList={['High', 'Medium', 'Low']} allItemRequired={true} />
        </Grid>
        <Grid xs={2}>
          <IDateField name='startDate' label='Start Date' />
        </Grid>
        <Grid xs={2}>
          <IDateField name='endDate' label='End Date' />
        </Grid>
      </Grid></SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <IGridComponent title={''} rows={scheduleData} columns={columns} loading={loading}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows} showAction={false}
        showAddBtn={false} showApproveAction={false} showDeleteAction={false} showUpAction={false} showDownAction={false}
        getRowId={(row: any) => row.rowId} showEditAction={true} handleEditAction={openEditPage} maxHeight={450}/>
    </>
  }

  return <TitlePanel title='Production Schedule' panelBody={getMainPanel()} />
}

export default ScheduleList;